import React, { Component } from "react";
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';

//Miscellaneous
import moment from "moment";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { Fade } from "react-awesome-reveal";
import Skeleton from "react-loading-skeleton";

//Components
import DateTimePicker from "../../components/DateTimePicker/DateTimePicker";
import Button from "../../components/Button/Button";
import { isDesktop } from "react-device-detect";

//Icons
import { Icon } from "@iconify/react";

// Actions
import MobilePersonalFinance from "./MobilePersonalFinance";
import { getList } from "../../store/ducks/financialReport/actions";

class PersonalFinance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: "personal_finance",
      start_date: moment().format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
      currentFilterDate: 0,
      transaction_date: '',

      /* api result array */
      total_deposit: 0,
      total_withdrawal: 0,
      total_dividend: 0,
      total_win_lose: 0,
      total_deducts: 0,

      /* skeleton loading */
      loading: true,
      dates: null,
      disableSearchButton: false,

      /* mobile */
      showDateSelect: false,
      showDate: '',
      selectedDate: '',

      spin: false,
      filterShow: ''
    };
    this.onInputChange = this.onInputChange.bind(this);
  }

  componentDidMount() {
    const listingArr = this.getFilterArray();
    this.props.getList(listingArr);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(nextProps.list !== undefined && nextProps.list !== this.props.list){
      if(nextProps.list.responseCode === 200 && nextProps.list.msgType === 'success'){
        this.setState({
          loading: false,
          total_deposit: nextProps.list.data.total_deposit,
          total_withdrawal: nextProps.list.data.total_withdrawal,
          total_dividend: nextProps.list.data.total_dividend,
          total_win_lose: nextProps.list.data.total_win_lose,
          total_deducts: nextProps.list.data.total_deducts || 0,
          disableSearchButton: false
        });
      }
    }
    return true;
  }

  getFilterArray = () => {
    const listingArr = {};
    listingArr.start_date = this.state.start_date;
    listingArr.end_date = this.state.end_date;
    return listingArr;
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  }

  onInputChange = (event) => {
    if (event.target.id === 'transaction_date') {
      const date = (event.target.value !== '') ? event.target.value.split(" - ") : null;
      this.setState({
        start_date: (date[0]) ? moment(date[0]).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        end_date: (date[1]) ? moment(date[1]).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        transaction_date: event.target.value,
      });

      const startDate = moment(this.state.start_date);
      const endDate = moment(this.state.end_date);
      const diff = endDate.diff(startDate, 'days');

      // Only allow to get data between 3 months
      if (diff > 92) {
        this.setState({
          disableSearchButton: true
        })
      } else {
        this.setState({
          disableSearchButton: false
        })
      }
    }
    else {
      this.setState({
        [event.target.name]: event.target.value,
      }, () => {
        this.searchHandler();
      });
    }
  }

  searchHandler = () => {
    this.setState({
      total_deposit: 0,
      total_withdrawal: 0,
      total_dividend: 0,
      total_win_lose: 0,
      loading: true,
      disableSearchButton: true
    }, () => {
      const listingArr = this.getFilterArray();
      this.props.getList(listingArr);
    });
  }

  filterDayRange = (val) => {
    // let days = Number(event.target.value);
    let days = val;
    let startDate = moment().subtract(days, "days").format("YYYY-MM-DD");
    let endDate = moment().format("YYYY-MM-DD");
    let transactionDate = `${moment(startDate).format("MM/DD/YYYY")} - ${moment(endDate).format("MM/DD/YYYY")}`;

    this.setState({
      start_date: startDate,
      end_date: endDate,
      transaction_date: transactionDate,
      // filterRange: days
    }, () => {
      let startDate = moment(this.state.start_date);
      let endDate = moment(this.state.end_date);
      let dayRange = endDate.diff(startDate, 'days');
      let disableButton = null;
      if (!startDate.isSameOrBefore(endDate) || !endDate.isSameOrAfter(startDate) || dayRange > 92) {
        disableButton = true;
      } else {
        disableButton = false;
      }

      this.setState({
        disableSearchButton: disableButton
      })

      this.searchHandler();
    });
  }

  //Mobile//
  toggleShowDateSelect = (e, show) => {
    if (this.state.showDateSelect === false) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }

    this.setState({
      showDateSelect: !this.state.showDateSelect,
    });

    const startDate = moment(this.state.start_date);
    const endDate = moment(this.state.end_date);
    const diff = endDate.diff(startDate, 'days');
    let disableButton = false;
    if(diff > 30){
      disableButton = true;
    }

    if (show === 'startDate') {
      this.setState({
        showDate: 'startDate',
        selectedDate: this.state.start_date,
        disableSearchButton: disableButton
      })
    } else if (show === 'endDate') {
      this.setState({
        showDate: 'endDate',
        selectedDate: this.state.end_date,
        disableSearchButton: disableButton
      })
    }
  }

  onChangeDateHandler = (value) => {
  const pad = (n) => String(n).padStart(2, "0");
  const picked = `${value.years}-${pad(value.months)}-${pad(value.days)}`;

  // Predict next range based on which date is being edited
  const nextStart = this.state.showDate === 'startDate' ? picked : this.state.start_date;
  const nextEnd   = this.state.showDate === 'endDate'   ? picked : this.state.end_date;

  // Validate range (keep in sync with backend: max 30 days, start <= end)
  const start = moment(nextStart, "YYYY-MM-DD", true);
  const end   = moment(nextEnd, "YYYY-MM-DD", true);
  const diff  = end.diff(start, "days");
  const invalid =
    !start.isValid() ||
    !end.isValid() ||
    end.isBefore(start) ||
    diff > 30;

  if (this.state.showDate === 'startDate') {
    this.setState({ start_date: picked, disableSearchButton: invalid });
  } else if (this.state.showDate === 'endDate') {
    this.setState({ end_date: picked, disableSearchButton: invalid });
  }
};


  onChangeFilterDateHandler = (value, e) => {
    this.setState({
      currentFilterDate: value
    });
  }

  onResetHandler = () => {
    this.setState({
      currentFilterDate: 0,
      start_date: moment().format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
      transaction_date: "",
      spin: true,
      loading: true,
      total_deposit: 0,
      total_withdrawal: 0,
      total_win_lose: 0,
      total_dividend: 0,
      total_deducts: 0
    }, () => {
      const listingArr = this.getFilterArray();
      this.props.getList(listingArr);
    });

    setTimeout(() => this.setState({ spin: false }), 2000);
  }

  render() {
    const { t } = this.props;
    const icons = this.imageImport(require.context("../../assets/images/deposit/icons", false, /\.(png|jpe?g|svg)$/));
    const resetIcon = this.imageImport(
      require.context("../../assets/images/icons", false, /\.(png|jpe?g|svg)$/)
    );

    const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };
    
    let filterCategories = [
      { id: "1", label: t('financial-report.deposit'), amount: new Intl.NumberFormat("en-US", num_format).format(this.state.total_deposit) },
      { id: "2", label: t('financial-report.withdrawal'), amount: new Intl.NumberFormat("en-US", num_format).format(this.state.total_withdrawal) },
      { id: "3", label: 'Dividend (USD)', amount: new Intl.NumberFormat("en-US", num_format).format(this.state.total_dividend) },
      // { id: "4", label: "Rebate", amount: "2,000.00" },
      // { id: "5", label: "Venue Fee", amount: "2,000.00" },
      { id: "4", label: t('financial-report.total-win-lose') + ' (USD)', amount: new Intl.NumberFormat("en-US", num_format).format(this.state.total_win_lose) },
      { id: "5", label: 'Deducts (USD)', amount: new Intl.NumberFormat("en-US", num_format).format(this.state.total_deducts) },
      // { id: "7", label: "Deposit and Withdrawal Fee", amount: "2,000.00" },
      // { id: "8", label: "Net Win/Loss", amount: "2,000.00" },
      // { id: "9", label: "Account Adjustment", amount: "2,000.00" },
    ];

    return (
      <Auxiliary>
        {isDesktop ? (
          <>
            <div className="pd-content pf-category">
              <div className="filters-col history-n-filter">
                <div className="filters-tp-panel row">
                  <div className="filters-tp-col col-5">
                    <label className="col-form-label">{t('financial-report.stat-time')}:</label>
                      <div className="input-group right">
                        <DateTimePicker
                          id="transaction_date"
                          name="transaction_date"
                          className="form-control"
                          autoUpdateInput={true}
                          autoApply={true}
                          format="MM/DD/YYYY"
                          value={this.state.transaction_date}
                          onChange={this.onInputChange}
                        />
                        <span className="input-group-text">
                          <Icon icon="uil:calendar-alt" />
                        </span>
                      </div>
                    </div>
                    <div className="filters-tp-col col-5">
                    <Button
                        typeButton="button"
                        classValue="btn btn-gradient-blue"
                        idValue="search"
                        buttonName={t('global.check')}
                        clicked={() => this.searchHandler()}
                        disabled={this.state.disableSearchButton}
                      />
                      <div className="reset-btn">
                        <img className={`${this.state.spin ? "spin" : ""} `} src={resetIcon["rotate-icon.svg"]} alt="reset" onClick={this.onResetHandler} />
                      </div>
                      </div>
                    </div>
              </div>
                <span className="mx-2">&nbsp;</span>
                <Fade duration={1000} triggerOnce>
                  <div className="row ">
                    {this.state.loading ? <Skeleton count={4} height={50} style={{ marginBottom: "1rem" }}/> :
                    filterCategories &&
                      filterCategories.map((item, index) => (
                        <div className="col-4" key={index}>
                          <div className="border-frame">
                          <p>{item.label}</p>
                          <h4>{item.amount}</h4>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </Fade>
                <span className="mx-2">&nbsp;</span>
              <p className="text-danger"><Icon icon="akar-icons:circle-alert-fill" /><strong>Note: </strong>A <strong>NEGATIVE</strong> value in "Total Win/Lose" means the company's PROFIT (members lost). A <strong>POSITIVE</strong> value means the company's LOSS (members won). Daily data is for general reference only and does not serve as the actual commission distribution standard.</p>
            </div>
          </>

        ) : (
          <MobilePersonalFinance
            filterCategories={filterCategories}
            onInputChange={this.onInputChange}
            filterDayRange={this.filterDayRange}

            icons={icons}

            searchHandler={this.searchHandler}

            onChangeDateHandler={this.onChangeDateHandler}
            toggleShowDateSelect={this.toggleShowDateSelect}

            onResetHandler={this.onResetHandler}
            onChangeFilterDateHandler={this.onChangeFilterDateHandler}

            {...this.state}
            {...this.props}
            onInputChangeHandler={this.onInputChangeHandler}
            showDateHandler={this.props.showDateHandler}
            offDateHandler={this.props.offDateHandler}
            showProviderHandler={this.props.showProviderHandler}
            showTypeHandler={this.props.showTypeHandler}
          />
        )
        }
      </Auxiliary>
    );
  }
}

//Received the response from the redux calling the api response
const mapStateToProps = state => {
  return {
    list: state.financialReport.list
  }
};

//Using the redux calling api methods
const mapDispatchToProps = dispatch => {
  return {
    getList: (data) => dispatch(getList(data))
  }
};

// Connect redux
export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces('translation')(PersonalFinance));

